define(['jquery', 'jquery.transit', 'modernizr', 'container', 'load-more', 'lightbox', 'preloader', 'underscore', 'jump'],
    function ($, transit, modernizr, container, loadMoreFactory,
              lightboxFactory, preloader, _, jumpFactory) {

        return (function () {

            const name = 'module-episode';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const loadMore = loadMoreFactory.create();
            const lightbox = lightboxFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {

            };

            model.methods = {
                getSeasonItems: function (season) {

                    const url = model.publicVars.ajaxSeasonEndpoint + '/' + season;

                    $.ajax({
                        url: url,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {
                        pubSub.publish('view/actionShowSeasonItems', data);
                    });
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentSeason: 1,
                videoSize: {
                    width: 932,
                    height: 524
                },
                player: null
            };

            view.startup = function () {

                view.privateVars.currentSeason = view.publicVars.initSeason;

                preloader.init();
                loadMore.init(view.publicVars.loadMoreSetup);
                loadMore.setAdditionalParamCallback(view.methods.getCurrentSeason);

                lightbox.init(view.publicVars.lightboxSetup);
                lightbox.setCloseCallback(view.methods.onLightboxClose);

                preloader.setPreloadBulk(name, view.publicVars.preloadTab);
            };

            view.bind = function () {

                $(view.publicVars.cssId.episodeButtonSelectListItemCls).click(function (e) {
                    e.stopPropagation();

                    const season = parseInt(container.getData($(this)[0], 'season'));
                    const seasonTxt = $(this).html();

                    if(season !== view.privateVars.currentSeason) {
                        view.methods.handleSeasonClick(season, seasonTxt);
                    } else {
                        view.methods.handleSelectOpen();
                    }
                });

                $(view.publicVars.cssId.episodeButtonSelectId).click(function () {
                    view.methods.handleSelectOpen();
                });

                $(document).mouseup(function(e)
                {
                    const container = $(view.publicVars.cssId.episodeButtonSelectId);

                    if (!container.is(e.target) // if the target of the click isn't the container...
                        && container.has(e.target).length === 0) // ... nor a descendant of the container
                    {
                        if($(view.publicVars.cssId.episodeButtonSelectListId).css('display') === 'block') {
                            view.methods.handleSelectOpen();
                        }
                    }
                });

                $(view.publicVars.cssId.episodeListInnerId).on('click',
                    view.publicVars.cssId.episodeTileImageCls + '' + view.publicVars.cssId.isVideoCls ,
                    function () {

                    const videoSrc = container.getData($(this)[0], 'video');
                    const videoPoster = container.getData($(this)[0], 'video.poster');

                    view.methods.handleVideoClick(videoSrc, videoPoster);
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);
                    }
                });
            };

            view.methods = {

                getCurrentSeason: () => {
                    return view.privateVars.currentSeason;
                },

                handleSelectOpen: () => {
                    if($(view.publicVars.cssId.episodeButtonSelectListId).css('display') === 'block') {
                        $(view.publicVars.cssId.episodeButtonSelectId).removeClass(view.publicVars.cssId.isOpenedCls.substr(1));
                        $(view.publicVars.cssId.episodeButtonSelectListId).fadeOut(200, function () {
                            $(view.publicVars.cssId.episodeButtonSelectId).removeClass(view.publicVars.cssId.isDisabledCls.substr(1));
                        });
                    } else {
                        $(view.publicVars.cssId.episodeButtonSelectId).addClass(view.publicVars.cssId.isOpenedCls.substr(1));
                        $(view.publicVars.cssId.episodeButtonSelectListId).fadeIn(200, function () {
                            $(view.publicVars.cssId.episodeButtonSelectId).addClass(view.publicVars.cssId.isDisabledCls.substr(1));
                        });
                    }
                },

                handleSeasonClick: (season, seasonTxt) => {

                    loadMore.disable();

                    view.privateVars.currentSeason = season;

                    $(view.publicVars.cssId.episodeButtonSelectTxtId).html(seasonTxt);

                    view.methods.handleSelectOpen();

                    const oldHeight = $(view.publicVars.cssId.episodeWrapperId).outerHeight();

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 0;
                    }

                    const newWindowHeight = $(window).height() - submenuHeight - headerHeight;

                    let newHeight = oldHeight;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                    }

                    $(view.publicVars.cssId.episodeId).transit({opacity: 0}, 300, function () {
                        $(view.publicVars.cssId.episodeWrapperId).css({ height: newHeight + 'px'});

                        $(view.publicVars.cssId.episodeListInnerId).html('');

                        $(view.publicVars.cssId.episodeWrapperId).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                        $(view.publicVars.cssId.episodeListLoaderId).css({display: 'block'});
                        $(view.publicVars.cssId.episodeListLoaderId).transit({opacity: 1});

                        jump.centerTo(view.publicVars.cssId.episodeListLoaderId, () => {
                            model.methods.getSeasonItems(season);
                        }, {
                            modifier: - parseInt(headerHeight + submenuHeight)
                        });
                    });


                },

                handleVideoClick: (videoSrc, videoPoster) => {
                    $('html').addClass(view.publicVars.cssId.episodeLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.episodeLightboxLoaderId).css({ display: 'block'});

                    $(view.publicVars.cssId.episodeLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    view.methods.calculateLightboxSize(view.privateVars.videoSize.width, view.privateVars.videoSize.height);

                    lightbox.showLayer(() => {

                        if(!view.privateVars.player) {
                            view.methods.setupBitmovin(view.publicVars.cssId.episodeLightboxPlayerVideoId.substr(1), {
                                autoplay: true,
                                source: {
                                    progressive: videoSrc,
                                    poster: videoPoster
                                }
                            });
                        } else {
                            view.privateVars.player.load({
                                progressive: videoSrc,
                                poster: videoPoster
                            });
                        }

                    });
                },

                setupBitmovin: (videoPlayerId, options) => {

                    const conf = {
                        key: view.publicVars.bitmovinKey,
                        analytics: false,
                        playback:{
                            autoplay: options.autoplay || false,
                            muted: true
                        },
                        logs: {
                            level: 'off'
                        },

                    };

                    let source = options.source || {
                        progressive: view.publicVars.introVideoSource
                    };

                    if(view.publicVars.introVideoPoster && !options.source) {
                        source.poster = view.publicVars.introVideoPoster;
                    }

                    view.privateVars.player = new bitmovin.player.Player(document.getElementById(videoPlayerId), conf);

                    // Setup the player
                    view.privateVars.player.load(source).then(function() {

                    }, function () {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.SourceLoaded, function(e) {
                        view.methods.showVideoItem();
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Error, function(e) {
                        view.methods.showVideoItem();
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Play, function(e) {

                        const state = container.getReduxStore().getState();

                        if(state.trailerPlayer) {
                            state.trailerPlayer.pause();
                        }

                        if(state.videoPlayerPlayer) {
                            state.videoPlayerPlayer.pause();
                        }

                        if(state.spotifyIframe) {
                            state.spotifyIframe.src = state.spotifyIframe.src;
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Playing, function(e) {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Paused, function(e) {

                    });


                    view.privateVars.player.on(bitmovin.player.PlayerEvent.PlaybackFinished, function(e) {

                    });
                },

                showVideoItem: (id) => {

                    $(view.publicVars.cssId.episodeLightboxLoaderId).transit({ opacity: 0}, () => {
                        $(view.publicVars.cssId.episodeLightboxLoaderId).css({ visibility: 'hidden'});

                        $(view.publicVars.cssId.episodeLightboxCls).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                        //view.privateVars.anim = 0;
                        $(view.publicVars.cssId.episodeLightboxPlayerId).transit({ visibility: 'visible', opacity: 1 }, 500, () => {

                        });
                    });
                },

                actionShowSeasonItems: (action, data) => {
                    const compiled = _.template($(view.publicVars.cssId.templateId).html());

                    const output = compiled({
                        data: data
                    });

                    $(view.publicVars.cssId.episodeListInnerId).html(output);

                    const oldHeight = $(view.publicVars.cssId.episodeWrapperId).outerHeight();

                    $(view.publicVars.cssId.episodeWrapperId).removeAttr('style');

                    const newHeight = $(view.publicVars.cssId.episodeWrapperId).outerHeight();

                    $(view.publicVars.cssId.episodeWrapperId).css({ height: oldHeight + 'px'});

                    $(view.publicVars.cssId.episodeListLoaderId).removeAttr('style');

                    $(view.publicVars.cssId.episodeWrapperId).transit({ height: newHeight + 'px'}, 300, () => {

                        $(view.publicVars.cssId.episodeWrapperId).removeAttr('style');

                        $(view.publicVars.cssId.episodeTileCls + view.publicVars.cssId.isAddedCls).removeClass(view.publicVars.cssId.isAddedCls.substr(1));

                        $(view.publicVars.cssId.episodeWrapperId).removeClass(view.publicVars.cssId.isLoadingCls.substr(1));

                        $(view.publicVars.cssId.episodeId).transit({opacity: 1}, 300, function () {

                        });

                        loadMore.enable(data);

                    });

                },

                onLightboxClose: () => {
                    $('html').removeClass(view.publicVars.cssId.episodeLightboxOpenCls.substr(1));
                    $(view.publicVars.cssId.episodeLightboxCls).addClass(view.publicVars.cssId.isLoadingCls.substr(1));

                    $(view.publicVars.cssId.episodeLightboxLoaderId).finish();
                    $(view.publicVars.cssId.episodeLightboxLoaderId).removeAttr('style');
                    $(view.publicVars.cssId.episodeLightboxLoaderId).css({ display: 'block'});

                    $(view.publicVars.cssId.episodeLightboxPlayerId).css({ opacity: 0});
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.episodeLightboxAreaCls).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.episodeLightboxAreaCls).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.episodeLightboxAreaCls).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.episodeLightboxAreaCls).css('padding-right'));

                    const border = parseInt($(view.publicVars.cssId.episodeLightboxAreaCls).css('border-width'));

                    const maxWidth = windowWidth - paddingLeft - paddingRight - border - border;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - border - border;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.videoSize.width;
                    let adjustedHeight = view.privateVars.videoSize.height;

                    if (width !== '' && height !== '' && parseInt(width) > 400 && parseInt(height) > 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + border + border;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + border + border;

                    $(view.publicVars.cssId.episodeLightboxAreaCls)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                },
            };

            /* custom events */
            pubSub.subscribe('view/actionShowSeasonItems', view.methods.actionShowSeasonItems);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
